import { useState } from 'react';
import type { FC } from 'react';

import { RadioGroupContainer, RadioGroupContainerLabel } from './styled';

import { Radio } from '../Radio';

export enum RadioGroupLayout {
    'vertical',
    'horizontal',
}

interface IRadioOption {
    value: string | number;
    label: string;
    disabled?: boolean;
}

interface IRadioGroup {
    onSelect?: (value?: string) => void;
    options: IRadioOption[];
    name: string;
    layout?: RadioGroupLayout;
    defaultValue?: string | number;
    disabled?: boolean;
    label?: string;
}

export const RadioGroup: FC<IRadioGroup> = ({
    disabled,
    defaultValue,
    onSelect,
    options,
    name,
    layout,
    label,
}) => {
    const [selectedValue, setSelectedValue] = useState(defaultValue);

    const onOptionSelected = (value?: string) => {
        setSelectedValue(value);

        if (onSelect) {
            onSelect(value);
        }
    };

    return (
        <RadioGroupContainerLabel>
            {label}
            <RadioGroupContainer layout={layout}>
                {options.map(
                    ({
                        value,
                        label: radioLabel,
                        disabled: radioDisabled = false,
                    }) => (
                        <Radio
                            key={radioLabel}
                            onSelect={onOptionSelected}
                            name={name}
                            checked={selectedValue === value}
                            disabled={radioDisabled || disabled}
                            label={radioLabel}
                            value={value}
                        />
                    )
                )}
            </RadioGroupContainer>
        </RadioGroupContainerLabel>
    );
};

RadioGroup.defaultProps = {
    disabled: false,
    defaultValue: undefined,
    layout: RadioGroupLayout.horizontal,
    label: '',
    onSelect: () => null,
};
